import React from "react"
import { Layout } from "../components/Layout/Layout"
import { PageTitle } from "../components/PageTitle/PageTitle"
import { EversportsWidget } from "../components/EversportsWidget"
import { EVERSPORTS_IDS } from "../config/eversportsWidgets"
import { graphql } from "gatsby"

interface PriceCardsProps {
  data: {
    cms: {
      page: {
        title: string
      }
    }
  }
}

const PriceCards: React.FC<PriceCardsProps> = ({ data }) => {
  return (
    <Layout withPadding>
      <div className="flex flex-col items-center sm:w-11/12 lg:w-full">
        <PageTitle>{data.cms.page.title}</PageTitle>
        {/*
          Eversports Widget — Class Passes / Kurskarten (shop)
          NOTE: the old "title" prop said "coupons from eversports" but the embed
          was list=shop (class passes), NOT vouchers. See VOUCHERS for coupons.
          OLD widget ID/URL: t4ez9i?list=shop → https://www.eversports.de/widget/w/t4ez9i?list=shop
          NEW widget ID: TODO — fill in from Eversports Manager > Settings > Widgets [NEW]
          Page: /price-cards (CMS page /kurskarten)
        */}
        <EversportsWidget
          widgetId={EVERSPORTS_IDS.PRICE_CARDS}
          label="class passes"
          className="mx-16 w-full bg-white px-8 py-4 lg:w-10/12"
        />
      </div>
    </Layout>
  )
}

export default PriceCards

export const query = graphql`
  {
    cms {
      page(id: "/kurskarten", idType: URI) {
        title
      }
    }
  }
`
